import mobileIcon from "../assets/icons/mobile.svg";
import webIcon from "../assets/icons/web.svg";
import uxIcon from "../assets/icons/ux.svg";
import databaseIcon from "../assets/icons/database.svg";
import devopsIcon from "../assets/icons/devops.svg";
import cloudIcon from "../assets/icons/cloud.svg";
import enterpriseIcon from "../assets/icons/entreprise.svg";
import aiIcon from "../assets/icons/service-ai.svg";
import securityIcon from "../assets/icons/service-security.svg";
import awsIcon from "../assets/icons/service-aws.svg";
import legacyIcon from "../assets/icons/service-legacy.svg";
import testingIcon from "../assets/icons/service-testing.svg";
import analysisIcon from "../assets/icons/service-analysis.svg";
import projectIcon from "../assets/icons/service-project.svg";
import architectureIcon from "../assets/icons/service-architecture.svg";

/** Service catalogue `id` → icon URL (same stroke palette #2C666E as industry icons). */
const SERVICE_ICON_BY_ID = {
  "73636": enterpriseIcon,
  "8798": mobileIcon,
  "8799": webIcon,
  "8802": uxIcon,
  "75532": aiIcon,
  "19596": databaseIcon,
  "8800": securityIcon,
  "54956": devopsIcon,
  "8801": cloudIcon,
  "9894": awsIcon,
  "54090": databaseIcon,
  "54304": enterpriseIcon,
  "8803": legacyIcon,
  "9804": testingIcon,
  "75425": enterpriseIcon,
  "8806": analysisIcon,
  "8808": projectIcon,
  "8807": architectureIcon,
};

const DEFAULT_SERVICE_ICON = webIcon;

export function getServiceIconSrc(serviceId) {
  const key = serviceId != null ? String(serviceId) : "";
  return SERVICE_ICON_BY_ID[key] ?? DEFAULT_SERVICE_ICON;
}
